import React from "react";
import Section from "@/components/ui/section";
import Image from "next/image";
import KnowMore from "@/components/ui/know-more";
import cn from "classnames";
import { SinglePoint } from "./key-facts";
export default function ClimateImpacts({ data, columns = 2 }) {
  return (
    <Section className="bg-white" variant="flat">
      <h5 className="text-darkBlue mt-8 font-medium"> Climate impacts</h5>
      <div
        className={cn(
          "md:grid md:auto-rows-auto flex flex-col md:gap-4 gap-4 w-full my-4",
          {
            "lg:grid-cols-2 md:grid-cols-1": columns == 2,
            "lg:grid-cols-3 md:grid-cols-1": columns == 3,
          }
        )}
      >
        {data.map((row, key) => (
          <IconBox
            data={row}
            key={"goals" + key}
            variant="light"
            columns={columns}
          />
        ))}
        {/* <a
          href="#"
          target="_blank"
          rel="noreferrer"
          className={cn(
            "overflow-hidden lg:min-h-[226px] min-h-[200px] lg:h-full h-[200px] rounded-2xl relative"
          )}
        >
          <Image
            src={"/images/home/gri-banner.jpg"}
            alt={"view eport"}
            fill
            className="w-full object-cover"
            sizes="(max-width: 479px) 400px,(max-width: 768px) 768px, (max-width: 1200px) 200px,(max-width: 1920px) 400px, 500px"
          />
          <div className="absolute top-0 left-0 w-full h-full flex bg-black/20 group justify-center items-center">
            <div className="lg:w-20 lg:h-20 h-10 w-10 relative group-hover:scale-105 transition-all duration-300 ease">
              <Image
                src={"/images/icons/pdf.png"}
                alt={"pdf icon"}
                fill
                className="w-full object-contain"
                sizes="(max-width: 479px) 200px,(max-width: 768px) 768px, (max-width: 1200px) 200px,(max-width: 1920px) 200px, 200px"
              />
            </div>
          </div>
        </a> */}
      </div>
      {/* <KnowMore
        variant="darkBlue"
        external={true}
        path="#"
        text="For more: read our Climate and migration report here."
      /> */}
    </Section>
  );
}
const IconBox = ({ data, variant = "dark", columns }) => {
  const { icon, title, description } = data;
  return (
    <div
      className={cn(
        {
          "bg-[#F1F7FF] hover:bg-white border-[#F1F7FF] hover:border-darkBlue":
            variant === "light",
          "bg-white hover:bg-[#F1F7FF] border-white hover:border-darkBlue":
            variant === "dark",
        },
        "w-full overflow-hidden h-full border-[1px] rounded-2xl flex flex-col gap-4 justify-start md:items-center items-center p-4 group transition-all duration-300 ease"
      )}
    >
      <div
        className={cn(
          {
            "bg-[#F1F7FF] group-hover:bg-white": variant === "dark",
            "bg-white group-hover:bg-[#F1F7FF]": variant === "light",
          },
          "relative lg:w-24 lg:h-24 h-20 w-20 rounded-2xl flex flex-col shrink-0 justify-center items-center transition-all duration-300 ease"
        )}
      >
        <Image
          src={icon}
          alt={title ?? "key fact icon"}
          fill
          className="w-full object-contain p-4"
          sizes="(max-width: 479px) 200px,(max-width: 768px) 768px, (max-width: 1200px) 200px,(max-width: 1920px) 200px, 200px"
        />
      </div>
      <div className="flex md:flex-row flex-col w-full h-full gap-8">
        <SinglePoint
          title={title}
          description={description}
          textPosition={"text-justify"}
        />
      </div>
    </div>
  );
};
